import { Box, Flex, FormControl, FormLabel, Input, Switch, Text } from '@chakra-ui/react'

import { FormField } from '../../../../components/FormField'
import { toDateTimeLocalValue } from '../../../../helpers'

interface IProps {
  isActive: boolean
  scheduledAt: string | null
  onActiveChange: (value: boolean) => void
  onScheduledAtChange: (value: string | null) => void
  isDisabled?: boolean
}

export function PostStatusControls({
  isActive,
  scheduledAt,
  onActiveChange,
  onScheduledAtChange,
  isDisabled = false
}: IProps) {
  const isScheduling = !!scheduledAt

  const handleActiveChange = (checked: boolean) => {
    onActiveChange(checked)
    // If manually activating, clear schedule
    if (checked) {
      onScheduledAtChange(null)
    }
  }

  const handleScheduleToggle = (checked: boolean) => {
    if (checked) {
      // Enable scheduling — deactivate post and pre-fill with tomorrow's date
      onActiveChange(false)
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      tomorrow.setSeconds(0, 0)
      onScheduledAtChange(toDateTimeLocalValue(tomorrow))
    } else {
      // Disable scheduling — clear scheduled date and restore active state
      onScheduledAtChange(null)
      onActiveChange(true)
    }
  }

  return (
    <Box border="1px solid" borderColor="gray.200" borderRadius="md" p={4}>
      <Flex align="center" justify="space-between">
        <FormControl w="auto" display="flex" alignItems="center" gap={2}>
          <Switch
            isChecked={isActive}
            onChange={(e) => handleActiveChange(e.target.checked)}
            isDisabled={isDisabled || isScheduling}
            id="is_active"
          />
          <FormLabel htmlFor="is_active" mb={0} fontSize="sm" cursor="pointer">
            Ativo
          </FormLabel>
        </FormControl>

        <FormControl w="auto" display="flex" alignItems="center" gap={2}>
          <Switch
            isChecked={isScheduling}
            onChange={(e) => handleScheduleToggle(e.target.checked)}
            isDisabled={isDisabled}
            id="schedule_toggle"
          />
          <FormLabel htmlFor="schedule_toggle" mb={0} fontSize="sm" cursor="pointer">
            Agendar Post
          </FormLabel>
        </FormControl>
      </Flex>

      {isScheduling && (
        <Box mt={3}>
          <FormField label="Data e hora de publicação" htmlFor="scheduled_at">
            <Input
              type="datetime-local"
              id="scheduled_at"
              value={scheduledAt || ''}
              onChange={(e) => onScheduledAtChange(e.target.value || null)}
              isDisabled={isDisabled}
              min={toDateTimeLocalValue(new Date())}
              size="sm"
            />
          </FormField>
          <Text variant="caption" mt={1}>
            O post será ativado automaticamente nesta data e hora.
          </Text>
        </Box>
      )}

      {isScheduling && isActive && (
        <Text fontSize="xs" color="orange.500" mt={2}>
          O post será desativado ao salvar e reativado na data agendada.
        </Text>
      )}
    </Box>
  )
}
